<template>
	<div class="contactBox" v-cloak>
		<div class="contactB" v-for="(year,index) in cbDATA">
			<p class="years" :id="index">{{year.years}}年</p>
			<div class="contactList" v-for="items in cbDATA[index].detail">
				<p class="time">
					<span class="mon">{{items.mon}}</span>
					<span class="ym">{{items.ym}}</span>
				</p>
				<img :src="items.img_url" alt="">
				<p class="describe">{{items.title}}</p>
			</div>
		</div>

		<ul class="contactListDirectory">
			<li v-for="(i,listIndex) in cbDATAList">
				<a class="contactListDirectoryA" :class="listIndex==0?'active':''" :href="'#'+(listIndex)" @click="actList(listIndex)">{{i}}<i></i></a>
			</li>
		</ul>

		<div class="homeBotTxt">
	        <p>Copyright ©2018 思考乐教育</p>
	        <div>
	          <router-link to="/LegalDeclaration">法律声明</router-link>
	          <span class="l">|</span>
	          <router-link :to="{name:'CampusCon',query:{id:1,cityId:1001}}">校区导航</router-link>
	        </div>
      	</div>	
	</div>
</template>

<script>
	export default{
		data(){
			return{
				cbDATA:'',
				cbDATAList:'',
				listRemoveId: 0
			}
		},
		created(){
			this.axios.get(this.$root.baseUrl+'/wap/aboutUs/brandData')
			.then(res=>{
				this.cbDATA = res.data.dataList;
				this.cbDATAList = res.data.yearList;
				console.log(res.data.dataList)
			})
			.catch(e=>{
				console.log(e)
			})
		},
		mounted(){
			 this.$foo = 5;
		},
		methods:{
			actList: function(listIndex){
				console.log(listIndex)
				console.log(this.listRemoveId)
				if(this.listRemoveId != listIndex){
					document.getElementsByClassName("contactListDirectoryA")[this.listRemoveId].classList.remove("active");
					this.listRemoveId = listIndex
				}
				document.getElementsByClassName("contactListDirectoryA")[listIndex].classList.add("active")
				console.log(document.getElementsByClassName("contactListDirectoryA")[0].classList)
				// document.getElementsByClassName("contactListDirectoryA").classList.remove("active");
				// document.getElementsByClassName("contactListDirectoryA")[listIndex].classList.add("active");
			}
		}
	}

	

</script>

<style scoped>
.contactBox{
   margin: 2.1333rem 0 0;
   font-size: 1rem;
   padding: 0 1rem;
   box-sizing: border-box;
}
.years{
    font-size: 1.6rem;
    font-weight: bold;
    margin: 2rem 0;
    color: #333;    
}
.contactList{
	width: 100%;
    margin: 1rem 0;	
}
.contactList img{
    display: inline-block;
    vertical-align: middle;
    height: 5.2rem;
    width: 6.1333rem;
    border-radius: 4px;
}
.time{
    width: 3.2rem;
    display: inline-block;
    vertical-align: middle;
    margin-right: 1.16667rem;
}
.mon{
	font-size: 2.4rem;
    display: block;
    text-align: center;
    color: #bfbfbf;
    height: 2.4rem;
    line-height: 2.4rem;
    margin-bottom: 0.6rem;
    font-weight: bold;    
}
.ym{
    text-align: center;
    width: 100%;
    display: block;
    font-size: 0.8rem;
    color: #bfbfbf;
}
.describe{
	width: 11.8rem;
    display: inline-block;
    min-height: 2rem;
    vertical-align: top;
    padding: 0 0 0 0.8333rem;
    box-sizing: border-box;
    color: #333;
}
.contactB{
    display: inline-block;
}
.contactListDirectory{
    position: fixed;
    top: 50%;
    right: 1rem;
    transform: translateY(-50%);
    -ms-transform: translateY(-50%);
    -moz-transform: translateY(-50%);
    -webkit-transform: translateY(-50%);
    -o-transform: translateY(-50%);
}
.contactListDirectory li{
	margin-bottom: 1rem;
    font-size: 0.8rem;	
}
.contactListDirectory a{
	color: #808080
}
.contactListDirectory a.active{
	color: #ff8800;
}
.contactListDirectory a.active i{
	display: inline-block;
    width: 0.26667rem;
    height: 0.26667rem;	
}
.contactListDirectory i{
    width: 0.5rem;
    height: 0.5rem;
    border-radius: 50%;
    display: inline-block;
    background: #ff8800;
    margin-left: 0.3rem;
    vertical-align: middle;
    display: none;
}
[v-cloak]{ display :none }
.homeBotTxt{
    /* position: fixed; */
    /* bottom: 1rem; */
    text-align: center;
    font-size: 1rem;
    color: #333;
    width: 100%;
    z-index: 99;
    color: #333;
    /* font-weight: 100; */
    margin: 4.8rem 0 1.333rem 0;
}
.homeBotTxt p{
    margin-bottom: 0.5rem;
    color: #808080;
}
.homeBotTxt a{
    color: #bfbfbf;
    text-decoration: underline;
    font-size: 0.8rem;
    /* font-weight: 100; */
}
.homeBotTxt .l{
    font-size: 0.8rem;
    display: inline-block;
    font-weight: bold;
    margin: 0 0.5rem;
    color: #bfbfbf;
}
</style>



// WEBPACK FOOTER //
// src/components/about/developmentHistoryBox.vue